export const orderTempState = {
  orderTempState: {
    startTime: '',
    endTime: '',
  },
};
export const orderTempMutations = {
  setOrderTemp(state, time) {
    state.orderTempState.startTime = time.startTime;
    state.orderTempState.endTime = time.endTime;
  },
};
export const orderTempActions = {
  setOrderTemp(test) {
    test.commit('setOrderTemp');
  },
};
